/* global $ */
import Chart from 'chart.js/auto';


const isResponsive = () => {
	return $(window).width() < 1051;
};

const renderDistrict = (id) => {
	const container = $('.js-map-data');
	const selected = container.find(".js-map-item[data-district='" + id + "']");
	container.find('.js-map-item').removeClass('js-open').hide();
	selected.addClass('js-open').show();
	scrollToElement('.map-box .js-map-data', 0);
};

const scrollToElement = (selector, duration) => {
	$('html, body').animate({ scrollTop: $(selector).offset().top - '70' }, duration);
};

const isInViewport = (elem) => {
	return (
		$(window).scrollTop() + $(window).height() >
		$(elem).offset().top + $(elem).height()
	);
};


$(document).ready(() => {
	$('.map-box .map-cont .district').on('click', (event) => {
		let elem = $(event.target);
		if (!elem.hasClass('district')) {
			elem = $(event.target).parents('.district');
		}
		$('.js-map-item .js-chart').removeClass('animated');
		$('.map-box .map-cont .district').removeClass('active');
		$(
			".map-box .map-cont .district[data-id='" + elem.data('id') + "']"
		).addClass('active');
		const id = elem.data('id').replace('district-', '');
		renderDistrict(id);
		window.history.pushState('', '', '#' + id);

		const dropDown = $('#customSelect');
		const selected = $('#archiveSearch option:selected');
		if (selected.val() !== id) {
			$('#archiveSearch option[value=' + id + ']')[0].selected = true;
			dropDown.find('span span').html(selected.text());
		}
	});

	$('.map-box .js-map-item .js-close-btn').on('click', () => {
		$('.js-map-item').hide();
		$('.map-box .map-cont .district').removeClass('active');
		scrollToElement('.map-box .map-box__map', 0);
	});

	$('.map-box #archiveSearch').on('change', (event) => {
		const id = $(event.target).val();
		$(
			".map-box .map-cont .district[data-id='district-" + id + "']"
		).click();
	});

	$(window).scroll(function () {
		$('.js-map-item.js-open .js-chart').each((key, item) => {
			if (isInViewport($(item)) && !$(item).hasClass('animated')) {
				const chart = Chart.getChart($(item).data('name'));
				const params = $(item).data('params');
				let cutout = $(item).data('name').indexOf('big') < 0 ? 60 : 70;
				if (cutout === 70 && isResponsive()) {
					cutout = 60;
				}
				if (chart !== undefined) {
					chart.destroy();
				}
				new Chart($('canvas', $(item)).get(0), {
					type: 'doughnut',
					data: {
						datasets: [
							{
								backgroundColor: [
									params.item1_bg,
									params.item2_bg,
								],
								data: [params.item1_value, params.item2_value],
								borderWidth: 5,
								borderColor: '#232446',
							},
						],
					},
					options: {
						cutout: cutout + '%',
						hoverBorderColor: '#222344',
						plugins: {
							tooltip: {
								enabled: false,
							},
						},
						animation: {
							duration: 2000,
						},
					},
				});
				$(item).addClass('animated');
			}
		});
	});

	if (window.location.hash) {
		const selected = parseInt(window.location.hash.replace('#', ''));
		$(
			".map-box .map-cont .district[data-id='district-" + selected + "']"
		).click();
	}
});
